export const modelsTagsList = [
  'All',
  'Top',
  'Image',
  'Video',
  'LLM',
  'Avatar',
  'Audio',
  'Music',
  'Enhance',
  'image',
  'Data',
  'Ecom',
  'Real_Estate',
  'Fun',
  'Face',
  'Fashion',
  '3D',
  'Transcribe',
  'Hair',
  'Beauty',
  'Text',
  'Animation',
  'Voice',
  'Drawing',
  'Speech',
  'Phone',
  'Photo',
  'Emoji',
  'Translation',
  'Communication',
]
